import React from 'react';
import { Col, FormGroup, FormGroupProps, FormLabel, FormLabelProps, FormText, FormTextProps, Row } from 'react-bootstrap';
import { FormikSelect, FormikSelectProps } from '../';
import { useLabel, useControlId } from '../FormGroupBase';

type FormGroupSelectProps = FormikSelectProps & {
  name: string;
  label?: string;
  feedback?: string;
  help?: string;
  labelProps?: FormLabelProps;
  groupProps?: FormGroupProps;
  helpProps?: FormTextProps;
  asRow?: boolean;
};

const FormGroupSelect = ({ label, help, labelProps, groupProps, helpProps, asRow = false, ...props }: FormGroupSelectProps) => {
  const { required, name } = props;
  const controlId = useControlId(name);
  const labelText = useLabel(label, required);

  if (asRow) {
    return (
      <FormGroup as={Row} {...groupProps} controlId={controlId}>
        <FormLabel column sm={4} {...labelProps}>
          {labelText}
        </FormLabel>
        <Col sm>
          <FormikSelect {...props} />
        </Col>
      </FormGroup>
    )
  }

  return (
    <FormGroup {...groupProps} controlId={controlId}>
      {labelText && <FormLabel {...labelProps}>{labelText}</FormLabel>}
      <FormikSelect {...props} />
      {help && (
        <FormText muted {...helpProps}>
          {help}
        </FormText>
      )}
    </FormGroup>
  );
};

export { FormGroupSelect, FormGroupSelectProps };
